import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getProductList = async (params = {}) => {
    return await api.post("/v1/webapp/getProductListByCompany", params);
};

export const getDropdownProduct = async (params = {}) => {
    return await api.post("/v1/dropdown/getProduct", params);
};

// export const getRequestLoanList = async (params = {}) => {
//     return await api.post("/v1/webapp/getRequestLoanList", params);
// };
// export const getRequestLoanListByCompany = async (params = {}) => {
//     return await api.post("/v1/webapp/getRequestLoanListByCompany", params);
// };

// export const getLoanTransferStatus = async (params = {}) => {
//     return await api.post("/v1/webapp/loanTransferStatus", params);
// };

// export const getUpdateTxnRequest = async (params = {}) => {
//     return await api.post("/v1/webapp/updateTxnRequest", params);
// };

// export const importWhitelist = async (params = {}) => {
//     return await apiFormData.post("/v1/webapp/importWhitelist", params);
// };
// export const exportExcelWhitelist = async (params = {}) => {
//     return await api.post("/v1/webapp/exportExcelWhitelist", params, {
//         responseType: 'blob'
//     });
// };

export const updateProductManagement = async (params = {}) => {
    return await apiFormData.post(
        "/v1/webapp/productManagement",
        params, {
        isFormData: true,
    });
};
